<template>
	<div class="app" @click="close" ref="app" @mousewheel="mousewheel" @mousedown="mousedown" @mouseup="mouseup">
		<div ref="list" class="list">
			<div @click.stop="open(item)" ref="item" class="item df fdc jcsb" v-for="item in data">
				<div class="short text_over">{{ item.short }}</div>
				<div class="title text_over">{{ item.title }}</div>
				<div class="time">{{ item.createdAt | dateFormat('yyyy-mm--dd') }}</div>
			</div>
		</div>
		<button-group @click="change"></button-group>
		<modal ref="modal" :show="show" :data="object"></modal>
		<CanvasStar></CanvasStar>
		<a href="https://beian.miit.gov.cn/" class="font-weight-bold font-md poa filingNo">闽ICP备2024058250号</a>
	</div>
</template>

<script>
import modal from '@/components/modal.vue'
import buttonGroup from '@/components/button-group.vue'
import CanvasStar from '@/components/CanvasStar.vue'
export default {
	name: 'app',
	components: {
		modal,
		buttonGroup,
		CanvasStar
	},
	data() {
		return {
			nowX: 0,
			lastX: 0,
			minusX: 0,
			nowY: 0,
			lastY: 0,
			minusY: 0,
			roY: 0,
			roX: 0,
			roZ: -2000,
			timer1: undefined,
			timer2: undefined,
			object: {},
			show: false,
			data: [],
			total: 0
		}
	},
	async mounted() {
		await this.getData()
		await this.init()
	},
	filters: {
		dateFormat(dataStr, pattern = 'yyyy-mm--dd hh:mm:ss') {
			// 根据给定的事件字符串,得到特定的时间
			let dt = new Date(dataStr)

			// yyyy-mm-dd
			let y = dt.getFullYear()
			let m = (dt.getMonth() + 1).toString().padStart(2, '0')
			let d = dt.getDate().toString().padStart(2, '0')
			let w = dt.getDay();
			let week = "日一二三四五六"[w];
			let hh = dt.getHours().toString().padStart(2, '0')
			let mm = dt.getMinutes().toString().padStart(2, '0')
			let ss = dt.getSeconds().toString().padStart(2, '0')

			switch (pattern.toLowerCase()) {
				case 'yyyy-mm--dd':
					return `${y}-${m}-${d}`
				case 'hh:mm:ss':
					return `${hh}:${mm}:${ss}`
				case 'w':
					return `周${week}`
				default:
					return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
			}
		}
	},
	methods: {
		async getData() {
			this.data = await this.$get('data');
		},
		close() {
			this.show = false;
		},
		open(object) {
			this.object = object;
			this.show = true;
		},
		mousedown({ clientX, clientY }) {
			this.lastX = clientX;
			this.lastY = clientY;
			clearInterval(this.timer1)
			this.$refs.app.addEventListener('mousemove', this.mousemove)
		},
		mouseup() {
			this.$refs.app.removeEventListener('mousemove', this.mousemove)
			this.timer1 = setInterval(() => {
				this.minusX *= 0.95;
				this.minusY *= 0.95;
				if (Math.abs(this.minusX) < 0.5) clearInterval(this.timer1)
				this.roY += this.minusX * 0.2;
				this.roX -= this.minusY * 0.2;
				this.$refs.list.style.transform = 'translateZ(' + this.roZ + 'px) rotateX(' + this.roX + 'deg) rotateY(' + this.roY + 'deg)'
			}, 13)
		},
		mousemove({ clientX, clientY }) {
			this.nowX = clientX;
			this.nowY = clientY;
			this.minusX = this.nowX - this.lastX;
			this.minusY = this.nowY - this.lastY;
			this.roY += this.minusX * 0.2;
			this.roX -= this.minusY * 0.2;
			this.$refs.list.style.transform = `translateZ(${this.roZ}px) rotateX(${this.roX}deg) rotateY(${this.roY}deg)`
			this.lastX = this.nowX;
			this.lastY = this.nowY;
		},
		mousewheel({ wheelDelta }) {
			this.roZ += wheelDelta;
			this.roZ = Math.min(0, this.roZ);
			this.roZ = Math.max(-8000, this.roZ);
			this.$refs.list.style.transform = 'translateZ(' + this.roZ + 'px) rotateX(' + this.roX + 'deg) rotateY(' + this.roY + 'deg)';
			this.timer2 = setInterval(() => {
				wheelDelta *= 0.85;
				if (Math.abs(wheelDelta) < 0.01) clearInterval(this.timer2);
				this.roZ += wheelDelta;
				this.roZ = Math.min(0, this.roZ);
				this.roZ = Math.max(-8000, this.roZ);
				this.$refs.list.style.transform = 'translateZ(' + this.roZ + 'px) rotateX(' + this.roX + 'deg) rotateY(' + this.roY + 'deg)';
			}, 13)
		},
		change(val) {
			this[val]()
		},
		init() {
			this.$refs.item.forEach(v => {
				v.style.transform = `translate3d(${(Math.random() - 0.5) * 5000}px,${(Math.random() - 0.5) * 5000}px,${(Math.random() - 0.5) * 5000}px)`
			})
			setTimeout(() => this.Table(), 300)
			document.onkeydown = ({ keyCode }) => {
				this.total += keyCode;
				if (this.total == 570) open('https://misaki.ren/public/project/233/index.html','_blank');
			}
			setInterval(() => this.total = 0, 4000)
		},
		// 整齐排版
		Grid() {
			let x = 400, y = 400, z = 800;//水平 垂直间隔
			let firstX = -2 * x;//第一个Li水平偏移量
			let firstY = -2 * y;//第一个Li垂直偏移量
			let firstZ = -2 * z;//第一个Li z轴偏移量
			this.$refs.item.forEach((v, i) => {
				let ix = (i % 25) % 5;//x方向增加的倍数
				let iy = parseInt((i % 25) / 5);//y方向增加的倍数
				let iz = parseInt(i / 25);//z方向增加的倍数
				v.style.transform = `translate3d(${firstX + ix * x}px,${firstY + iy * y}px,${firstZ + iz * z}px)`
			})
		},
		//螺旋排版
		Helix() {
			let roY = 10, y = 15;
			let midLi = Math.floor(this.$refs.item.length / 2);
			let firstY = -10 * midLi;
			this.$refs.item.forEach((v, i) => {
				v.style.transform = `rotateY(${15 * i}deg) translateY(${firstY + y * i}px) translateZ(1000px)`
			})
		},
		//球形排版
		Sphere() {
			let z = 800;
			let firstRox = 0;
			let firstRoy = 0;
			let roX = 20, roY = 360 / (this.$refs.item.length / 6);
			this.$refs.item.forEach((v, i) => {
				let iY = Math.floor(i / 18);
				v.style.transform = `rotateY(${firstRoy + iY * roY}deg) rotateX(${firstRox + 20 * i}deg) translateZ(${z}px)`
			});
		},
		//表格排版
		Table() {
			let tX = 210, tY = 270;
			let firstX = -9 * tX + 60;
			let firstY = -4 * tY;
			let arr = [
				{ x: firstX, y: firstY },
				{ x: firstX + 17 * tX, y: firstY },
				{ x: firstX, y: firstY + tY },
				{ x: firstX + tX, y: firstY + tY },
				{ x: firstX + 12 * tX, y: firstY + tY },
				{ x: firstX + 13 * tX, y: firstY + tY },
				{ x: firstX + 14 * tX, y: firstY + tY },
				{ x: firstX + 15 * tX, y: firstY + tY },
				{ x: firstX + 16 * tX, y: firstY + tY },
				{ x: firstX + 17 * tX, y: firstY + tY },
				{ x: firstX, y: firstY + tY * 2 },
				{ x: firstX + tX, y: firstY + tY * 2 },
				{ x: firstX + 12 * tX, y: firstY + tY * 2 },
				{ x: firstX + 13 * tX, y: firstY + tY * 2 },
				{ x: firstX + 14 * tX, y: firstY + tY * 2 },
				{ x: firstX + 15 * tX, y: firstY + tY * 2 },
				{ x: firstX + 16 * tX, y: firstY + tY * 2 },
				{ x: firstX + 17 * tX, y: firstY + tY * 2 }
			];
			let arr1 = [
				{ x: firstX + 3 * tX, y: firstY + tY * 8 },
				{ x: firstX + 4 * tX, y: firstY + tY * 8 },
				{ x: firstX + 5 * tX, y: firstY + tY * 8 },
				{ x: firstX + 6 * tX, y: firstY + tY * 8 },
				{ x: firstX + 7 * tX, y: firstY + tY * 8 },
				{ x: firstX + 8 * tX, y: firstY + tY * 8 },
				{ x: firstX + 9 * tX, y: firstY + tY * 8 },
				{ x: firstX + 10 * tX, y: firstY + tY * 8 },
				{ x: firstX + 11 * tX, y: firstY + tY * 8 },
				{ x: firstX + 12 * tX, y: firstY + tY * 8 },
				{ x: firstX + 13 * tX, y: firstY + tY * 8 },
				{ x: firstX + 14 * tX, y: firstY + tY * 8 },
				{ x: firstX + 15 * tX, y: firstY + tY * 8 },
				{ x: firstX + 16 * tX, y: firstY + tY * 8 },
				{ x: firstX + 17 * tX, y: firstY + tY * 8 },
				{ x: firstX + 3 * tX, y: firstY + tY * 9 },
				{ x: firstX + 4 * tX, y: firstY + tY * 9 },
				{ x: firstX + 5 * tX, y: firstY + tY * 9 },
				{ x: firstX + 6 * tX, y: firstY + tY * 9 },
				{ x: firstX + 7 * tX, y: firstY + tY * 9 },
				{ x: firstX + 8 * tX, y: firstY + tY * 9 },
				{ x: firstX + 9 * tX, y: firstY + tY * 9 },
				{ x: firstX + 10 * tX, y: firstY + tY * 9 },
				{ x: firstX + 11 * tX, y: firstY + tY * 9 },
				{ x: firstX + 12 * tX, y: firstY + tY * 9 },
				{ x: firstX + 13 * tX, y: firstY + tY * 9 },
				{ x: firstX + 14 * tX, y: firstY + tY * 9 },
				{ x: firstX + 15 * tX, y: firstY + tY * 9 },
				{ x: firstX + 16 * tX, y: firstY + tY * 9 },
				{ x: firstX + 17 * tX, y: firstY + tY * 9 }
			];
			this.$refs.item.forEach((v, i) => {
				let x, y;
				if (i < 18) {
					x = arr[i].x;
					y = arr[i].y;
				}
				else if (i > 89 && i < 120) {
					x = arr1[i % 89 - 1].x;
					y = arr1[i % 89 - 1].y;
				}
				else {
					let iX = (i + 18) % 18;
					let iY = parseInt((i + 18) / 18) + 1;
					x = firstX + iX * tX;
					y = firstY + iY * tY;
				}
				v.style.transform = `translate(${x}px,${y}px)`;
			});
		}
	}
}
</script>

<style lang="scss">
@import '../common/index.scss';
@import '../common/free.css';
* {
	margin: 0;
	padding: 0;
}

.app {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	perspective: 900px;
	background: no-repeat linear-gradient(to bottom, rgba(0, 127, 127, 1) 0%, #000 100%);
	
	.filingNo{
		bottom: 15px;
		left: 50%;
		transform: translateX(-50%);
		text-decoration: none;
		background-image: linear-gradient(rgba(0, 127, 127, 1), #fff);
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent; /*需要文字透明*/
	}
	.list {
		position: absolute;
		top: 50%;
		left: 50%;
		height: 0;
		width: 0;
		transform-style: preserve-3d;
		transform: translateZ(-2000px) rotateX(0deg) rotateY(0deg);

		.item {
			width: 180px;
			height: 240px;
			user-select: none;
			margin-left: -60px;
			margin-top: -80px;
			background: rgba(0, 127, 127, .5);
			border: 1px solid rgba(127, 255, 255, .25);
			box-shadow: 0 0 12px rgba(0, 255, 255, .5);
			transform-style: preserve-3d;
			perspective: 100;
			-webkit-perspective: 100;
			/* Safari 和 Chrome */
			cursor: pointer;
			position: absolute;
			transition: 3s ease-in-out;
			text-align: center;
			padding: 5px;

			.short {
				color: rgba(255, 255, 255, .7);
				margin-top: 10px;
				font-weight: bold;
				font-size: 70px;
				text-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
			}

			.title,
			.time {
				font-weight: bold;
				color: rgba(127, 255, 255, 0.75);
			}

			.title {
				font-size: 25px;
				margin-top: 35px;
				letter-spacing: 3px;
			}

			.time {
				margin-bottom: 10px;
				font-size: 32px;
				text-shadow: 0 0 5px rgba(0, 255, 255, 0.5);
			}

			&:hover {
				border: 1px solid rgba(127, 255, 255, .75);
				box-shadow: 0 0 12px rgba(0, 255, 255, .75);
			}
		}
	}

}
</style>
